import React from 'react';
import { Search, SearchIconWrapper, StyledInputBase } from 'components';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import { IconButton, Tooltip, Box } from 'components/mui';

interface AddressSearchProps {
  searchInput: string;
  onSearchInput: (input: string) => void;
  onReset: () => void;
}

function AddressSearch({ searchInput, onSearchInput, onReset }: AddressSearchProps) {
  const onClick = () => {
    onSearchInput('');
    onReset();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputWord = e.target.value;
    onSearchInput(inputWord);
  };

  return (
    <Box sx={{ width: '100%', '& > div': { width: '100%', ml: 0 }, '& .MuiInputBase-input': { width: '100% !important' } }}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search addresses..."
          value={searchInput}
          onChange={onChange}
          sx={{ width: '100%' }}
          endAdornment={
            searchInput ? (
              <Tooltip title="Clear">
                <IconButton onClick={onClick}>
                  <CloseOutlinedIcon />
                </IconButton>
              </Tooltip>
            ) : null
          }
        />
      </Search>
    </Box>
  );
}

export default AddressSearch;
